import React from "react";

interface PlanIconProps {
  className?: string;
}

export const PlanIcon: React.FC<PlanIconProps> = ({ className }) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="16.9997" cy="17" r="13.6667" stroke="currentColor" />
    <circle cx="16.9989" cy="16.9991" r="9.61905" stroke="currentColor" />
    <circle cx="16.9982" cy="17.0015" r="5.57143" stroke="currentColor" />
  </svg>
);
